import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { JwtAuthService } from 'app/shared/services/auth/jwt-auth.service';


@Pipe({
    name: 'authimage'
  })
  export class AuthImagePipe implements PipeTransform {

    constructor(
      private http: HttpClient,
      public jwtAuthService: JwtAuthService
    ) {}

    async transform(src: string): Promise<string> {
        const token = this.jwtAuthService.getJwtTokenByUrl(src);
        const headers = new HttpHeaders({'Authorization': `Bearer ${token}`});
        try {
          const imageBlob = await this.http.get(src, {headers, responseType: 'blob'}).toPromise();
          const reader = new FileReader();
          return new Promise((resolve, reject) => {
            reader.onloadend = () => resolve(reader.result as string);
            reader.readAsDataURL(imageBlob);
          });
        } catch {
          return './assets/images/no-image.jpeg';
        }
      }
  }
